module.exports = __webpack_public_path__ + "img/Z6.032dc738.png";